import { theme } from "@theme";
import { useEffect } from "react";
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withTiming,
} from "react-native-reanimated";

const STARTING_BALL_SIZE = 13;
const ENDING_BALL_SIZE = 17;

type LoadingCircleProps = {
  delay?: number;
};

const LoadingCircle = ({ delay = 0 }: LoadingCircleProps) => {
  const size = useSharedValue(STARTING_BALL_SIZE);

  const animatedStyle = useAnimatedStyle(() => ({
    width: size.value,
    height: size.value,
    borderRadius: size.value / 2,
    backgroundColor: theme.colors.lightGrey,
    margin: 5,
  }));

  useEffect(() => {
    size.set(
      withDelay(
        delay,
        withRepeat(
          withTiming(ENDING_BALL_SIZE, {
            duration: 1000,
            easing: Easing.inOut(Easing.ease),
          }),
          -1,
          true,
        ),
      ),
    );
  }, [delay, size]);

  return <Animated.View style={animatedStyle} />;
};

export default LoadingCircle;
